import { CnSearch as UiCnSearch } from "../../components/cn-search";
import { connect, mapProps } from '@formily/react';
import { mapSize, mapStatus } from '../__builtins__';
export var CnSearch = connect(UiCnSearch, mapProps({
    value: 'value',
}, mapSize, mapStatus));
